import React, { useState } from 'react';
import './ReviewModal.css';

const ReviewModal = ({ callId, textReadingId, onClose, onSubmitted }) => {
  const [rating, setRating] = useState(0);
  const [hoveredStar, setHoveredStar] = useState(0);
  const [reviewText, setReviewText] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');

  const handleBackdropClick = (e) => {
    if (e.target.className === 'review-modal-overlay') {
      onClose();
    }
  };

  const handleSubmit = async () => {
    if (rating === 0) {
      setError('Please select a star rating');
      return;
    }

    setError('');
    setIsSubmitting(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch('/api/v1/reviews', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...(callId ? { call_id: callId } : { text_reading_id: textReadingId }),
          rating,
          review_text: reviewText.trim() || null,
        }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.detail || 'Failed to submit review');
      }

      onSubmitted();
    } catch (err) {
      setError(err.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="review-modal-overlay" onClick={handleBackdropClick}>
      <div className="review-modal-card">
        <button className="review-modal-close" onClick={onClose}>×</button>
        <h2>Rate Your Reading</h2>
        <p className="review-modal-subtitle">
          {textReadingId ? 'How helpful was this AI answer?' : 'How was your experience?'}
        </p>

        <div className="star-rating">
          {[1, 2, 3, 4, 5].map((star) => (
            <button
              key={star}
              className={`star-btn ${star <= (hoveredStar || rating) ? 'active' : ''}`}
              onMouseEnter={() => setHoveredStar(star)}
              onMouseLeave={() => setHoveredStar(0)}
              onClick={() => setRating(star)}
              type="button"
            >
              ★
            </button>
          ))}
        </div>

        <textarea
          className="review-textarea"
          placeholder={textReadingId ? 'Add a comment about this answer... (optional)' : 'Tell us about your reading experience... (optional)'}
          value={reviewText}
          onChange={(e) => setReviewText(e.target.value)}
          maxLength={1000}
          rows={4}
        />

        {error && <div className="review-error">{error}</div>}

        <button
          className="review-submit-btn"
          onClick={handleSubmit}
          disabled={isSubmitting || rating === 0}
        >
          {isSubmitting ? 'Submitting...' : 'Submit Review'}
        </button>
      </div>
    </div>
  );
};

export default ReviewModal;
